import { FeedbackItem, WorkspaceState } from "../types/feedback.types";

export interface PipStoreData {
  cardDbId: number;
  workspaceId: number;
  feedbackName: string;
  previewImage: string;
  feedbackItems: FeedbackItem[];
  workspaceState: WorkspaceState | null;
}

let _store: PipStoreData | null = null;

export const pipStore = {
  set: (data: PipStoreData) => {
    _store = data;
  },
  get: (): PipStoreData | null => _store,
  clear: () => {
    _store = null;
  },
};
